export const modernurban = {
  name: 'Modern & Urban',
  color: [0.25882352941176473, 0.43137254901960786, 0.5254901960784314, 1],
  bg: [0.9764705882352941, 0.7294117647058823, 0.19607843137254902, 1],
  grid1: [0.9725490196078431, 0.9450980392156862, 0.8980392156862745, 1],
  grid2: [0.1843137254901961, 0.19215686274509805, 0.19215686274509805, 1],
}
